module.exports = __webpack_public_path__ + "static/media/persons.4950e748.svg";